import { isEmpty } from "lodash";
import { createContext, useEffect, useState } from "react";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
    const [auth, setAuth] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // console.log("LOCAL AUTH => ", localAuth);
        const storedUser = localStorage.getItem("user");

        if (storedUser) {
            setAuth(JSON.parse(storedUser));
        }
        setLoading(false);
    }, []);

    const login = (userData) => {
        console.log("🚀 ~ login ~ userData:", userData);

        setAuth(userData);
        localStorage.setItem("user", JSON.stringify(userData));
    };

    const logout = () => {
        setAuth(null);
        localStorage.removeItem("user");
    };

    const isAuthenticated = !!auth;

    const authContextValue = {
        auth,
        isAuthenticated,
        login,
        logout,
    };

    return <AuthContext.Provider value={authContextValue}>{!loading && children}</AuthContext.Provider>;
};

export default AuthContext;
